// import: styles
import { Box, Modal } from '@mui/material';

// import: assets
import Google from 'core/assets/img/auth-page/google.webp';
import Image from 'core/assets/img/signed-out-modal/signed-out-modal.webp';
import { ReactComponent as Logo } from 'core/assets/svg/app-bar/logo.svg';
import BaseButton from 'core/components/button/BaseButton';
import BaseImage from 'core/components/image/BaseImage';

// import: components
import BaseTypography from 'core/components/typography/BaseTypography';
import { AmplitudeEvents } from 'core/constants/AmplitudeEvents';

// import: constants
import { PostHogEvents } from 'core/constants/PostHogEvents';
import { signedOutModalStyles } from 'core/layouts/components/signed-out-modal/SignedOutModalStyles';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';

// import: redux
import {
	openSignedOutModalSelector,
	toggleSignedOutModal,
} from 'core/store/reducers/appReducer/AppSlice';
import { signInWithGoogle } from 'core/store/reducers/appReducer/appSliceThunk';
import { captureAmplitudeEvent } from 'core/utils/AmplitudeUtils.ts';

// import: utils
import { capturePosthogEvent } from 'core/utils/PosthogUtil.ts';
import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import: lazy load components

function SignedOutModal() {
	const dispatch = useDispatch();

	const open = useSelector(openSignedOutModalSelector);
	const handleClose = () => dispatch(toggleSignedOutModal(false));

	useEffect(() => {
		if (open) {
			capturePosthogEvent(PostHogEvents.SIGNED_OUT_POP_UP_ARRIVE);
			captureAmplitudeEvent(AmplitudeEvents.SIGNED_OUT_POP_UP_ARRIVE);
		}
	}, [open]);

	return (
		<Modal
			id="signed-out-modal"
			open={open}
			onClose={handleClose}
			aria-labelledby="sing-in-modal"
			aria-describedby="Sign in to get free image generation credits!"
		>
			<Box id="signed-out-modal-wrapper" sx={signedOutModalStyles.modalWrapper}>
				<Box id="modal-body" sx={signedOutModalStyles.modalBody}>
					<Box id="content-wrapper" sx={[signedOutModalStyles.contentWrapper]}>
						<Box id="content" sx={[reusableStyles.flexRow, signedOutModalStyles.content]}>
							<Box id="image-wrapper" sx={signedOutModalStyles.imgWrapper}>
								<Box id="image-cont" sx={signedOutModalStyles.imgCont}>
									<Box id="image" sx={[signedOutModalStyles.image]}>
										<BaseImage src={Image} alt="" />
									</Box>
								</Box>
							</Box>

							<Box id="text-cont" sx={signedOutModalStyles.textCont}>
								<Logo />
								<Box sx={[reusableStyles.flexCol, { margin: '16px 0', gap: '4px' }]}>
									<BaseTypography variant="nd2" styles={signedOutModalStyles.title}>
										You’ve been signed out
									</BaseTypography>
									<BaseTypography variant="body1" styles={signedOutModalStyles.subTitle}>
										Let’s sign in and keep going!
									</BaseTypography>
								</Box>
								<BaseButton
									id="continue-with-google-button"
									styles={signedOutModalStyles.continueWithGoogleButton}
									onClick={() => {
										capturePosthogEvent(PostHogEvents.SIGNED_OUT_CONTW_GOOGLE_CLICK);
										captureAmplitudeEvent(AmplitudeEvents.SIGNED_OUT_CONTW_GOOGLE_CLICK);
										dispatch(signInWithGoogle());
									}}
								>
									<BaseImage src={Google} alt="" />
									<BaseTypography variant="b1_medium" styles={{ color: 'colors.grey700' }}>
										Continue with Google
									</BaseTypography>
								</BaseButton>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
}

export default SignedOutModal;
